// extracted by mini-css-extract-plugin
export var csatScore = "_et-5";
export var header = "_et-1";
export var panelWrapper = "_et-2";
export var postPreview = "_et-3";
export var rightContent = "_et-0";
export var wrappingText = "_et-4";